import script from "./ExpandableItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExpandableItem.vue?vue&type=script&lang=ts&setup=true"

import "./ExpandableItem.vue?vue&type=style&index=0&id=b80d82ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b80d82ee"]])

export default __exports__